import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { productImageSrc } from "@/lib/images";
import { HERO_TRANSITION } from "@/lib/heroMotion";
import HeroPriceCard from "@/components/HeroPriceCard";

const HeroVisual = ({ slide, slideData }) => {
  const imageUrl = productImageSrc(slideData.image, "md");

  return (
    <div className="hero-right-col" data-testid="hero-visual" style={{ "--hero-accent": slideData.accent }}>
      <div className="hero-arch-wrap">
        <div className="hero-slide-stage">
          <AnimatePresence initial={false} mode="sync">
            <motion.div
              key={slide}
              className="hero-slide-layer"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0, pointerEvents: "none" }}
              transition={HERO_TRANSITION}
            >
              <div
                className="hero-arch"
                style={{ backgroundImage: `url(${imageUrl})` }}
                data-testid="hero-image"
              >
                <div className="hero-arch-shine" aria-hidden />
              </div>

              <div
                className="hero-mini-frame hidden lg:block"
                style={{ backgroundImage: `url(${imageUrl})` }}
                data-testid="hero-mini"
                aria-hidden
              />

              <HeroPriceCard
                slideKey={slide}
                tag={slideData.priceTag}
                productName={slideData.productName}
                price={slideData.priceLabel}
                note={slideData.priceNote}
                ctaTo={slideData.productTo}
                accent={slideData.accent}
                disableMotion
              />
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default HeroVisual;
